import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { H1, Sub } from "./_shared";

export default function FacilityClaimsSection() {
  const [filter, setFilter] = useState("pending");
  const [rows, setRows] = useState([]);
  const load = useCallback(() => {
    api.get(`/admin/facility-claims?status=${filter}`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [filter]);
  useEffect(() => { load(); }, [load]);
  const approve = async (cid) => { try { await api.post(`/admin/facility-claims/${cid}/approve`); toast.success("Approved"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); } };
  const reject = async (cid) => { if (!window.confirm("Reject this claim?")) return; try { await api.post(`/admin/facility-claims/${cid}/reject`); toast.success("Rejected"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); } };
  return (
    <div data-testid="cp-claims">
      <H1>Facility claims</H1>
      <Sub>Approve venue managers — once approved they can edit description, photos, hours and pricing.</Sub>
      <div className="mt-4 flex gap-2">
        {["pending", "approved", "rejected", "all"].map((s) => (
          <button key={s} onClick={() => setFilter(s)} data-testid={`cp-claims-filter-${s}`}
            className={`pp-chip ${filter === s ? "pp-chip-active" : ""}`}>{s}</button>
        ))}
      </div>
      <div className="mt-4 pp-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-wider text-zinc-500 bg-white/5"><tr>
            <th className="text-start px-4 py-3">Venue</th>
            <th className="text-start px-4 py-3">Claimant</th>
            <th className="text-start px-4 py-3">Message</th>
            <th className="text-start px-4 py-3">Status</th>
            <th className="text-end px-4 py-3">Actions</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-white/5" data-testid={`cp-claim-row-${r.id}`}>
                <td className="px-4 py-2">
                  <Link to={`/facilities/${r.facility?.id || r.facility_id}`} className="text-[#00E676] hover:underline">
                    {r.facility?.name || r.facility_id?.slice(0, 8)}
                  </Link>
                  <div className="text-[11px] text-zinc-500">{r.facility?.city}{r.facility?.country ? `, ${r.facility.country}` : ""}</div>
                </td>
                <td className="px-4 py-2 text-xs">
                  <div>{r.user_name || "—"}</div>
                  <div className="text-zinc-500">{r.user_email}</div>
                  <div className="pp-chip text-[10px] mt-1">{r.user_role}</div>
                </td>
                <td className="px-4 py-2 text-xs text-zinc-400 max-w-[260px]">
                  <div className="truncate" title={r.message || ""}>{r.message || "—"}</div>
                  {r.contact_phone && <div className="text-[11px] text-zinc-500 mt-1">📞 {r.contact_phone}</div>}
                </td>
                <td className="px-4 py-2"><span className={`pp-chip ${r.status === "approved" ? "pp-chip-active" : r.status === "rejected" ? "border-[#FF3B30]/30 text-[#FF3B30]" : "border-[#FFD60A]/30 text-[#FFD60A]"}`}>{r.status}</span></td>
                <td className="px-4 py-2 text-end">
                  {r.status === "pending" && (
                    <div className="inline-flex gap-1">
                      <button onClick={() => approve(r.id)} data-testid={`cp-claim-approve-${r.id}`} className="pp-btn-primary px-3 py-1 rounded-lg text-xs">Approve</button>
                      <button onClick={() => reject(r.id)} data-testid={`cp-claim-reject-${r.id}`} className="pp-btn-secondary px-3 py-1 rounded-lg text-xs border-[#FF3B30]/30 text-[#FF3B30]">Reject</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="text-center text-zinc-500 py-10">No {filter} claims.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
